import type * as React from 'react';
const SvgIcoNewReleases = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m23 11.995-2.44-2.78.34-3.68-3.61-.82-1.89-3.18-3.4 1.46-3.4-1.46-1.89 3.18-3.61.81.34 3.68L1 11.995l2.44 2.78-.34 3.69 3.61.82 1.89 3.18 3.4-1.47 3.4 1.46 1.89-3.18 3.61-.82-.34-3.68zm-4.51 2.11.26 2.79-2.74.62-1.43 2.41-2.58-1.11-2.58 1.11-1.43-2.41-2.74-.62.26-2.8-1.85-2.1 1.85-2.12-.26-2.78 2.74-.61 1.43-2.41 2.58 1.1 2.58-1.11 1.43 2.41 2.74.62-.26 2.79 1.85 2.11zm-7.49.89h2v2h-2zm0-8h2v6h-2z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIcoNewReleases;
